import { useSelector } from "react-redux";
import DataCollectionPackages from "../../../components/DataCollection/Monitoring/Dc_Packages/DataCollectionPackages";
import { selectUserData } from "../../../features/userSlice";
import { CheckPermissions } from "../../../logic/Admin/Permissions/CheckPermission/CheckPermissions";
import Page404 from "../../../components/Page404/Page403";

const DataCollectionPackagesScreen = () => {
  const response = useSelector(selectUserData);
  const hasMonitoringPackagesViewPermission = CheckPermissions(
    response?.data?.products?.data_collection,
    "monitoring",
    "view_monitoring"
  );

  return (
    <>
      {hasMonitoringPackagesViewPermission ? (
        <>
          <DataCollectionPackages />
        </>
      ) : (
        <Page404 />
      )}
    </>
  );
};

export default DataCollectionPackagesScreen;
